import { styled } from 'styled-components'
import Card from './card.jsx'
import { useState} from 'react'
import { useSelector,useDispatch } from 'react-redux';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { modifcarShoppingCart } from '../../redux/actions/shoppingCartActions.js'

const Container=styled.div`
	margin:8px;
	
	position:relative;
	display:inline-flex;
	flex-direction:column;
	align-items:center;	
	height:300px;
	font-family: "Poppins", sans-serif;
	width:180px;
	box-Shadow:0 10px 20px 5px rgba(0,0,0,0.02); 
	border-radius:10px;
	transition: all 50ms;
	&:hover{
		scale:1.01
	}
 `;
const Descripcion=styled.div`
	display:flex;
	flex-direction:column;
	text-align:left;
	font-family: "Roboto", sans-serif;  	
  	font-style: normal;
  	color :white;
  	width:100%;
  	box-sizing:content-box 	
}
 `;

 const Nombre=styled.div`
	font-size:15px;
  	color :white;
  	margin-top:5px;
	margin-left:0px
}
 `;



const Precio=styled.div`
	font-size:14px;
	margin:11px;
	margin-left:0px
	
 `;
const TipoCuenta=styled.div`
	font-size:12px;
	margin:5px;
	margin-left:0px
 `;
const Usuario=styled.div`
	font-size:10px;
	margin:5px;
	color:gray;
	margin-left:0px
 `;


const ContainerCard=styled.div`
	max-height:180px;
	width:100%;
	position:relative;
	margin-bottom:15px
`;

const AddCart=styled.div`
	position:absolute;
	bottom:05px;
	right:10px;
	background-color:white;
	display:flex;
	justify-content:center;
	align-items:center;
	height:14%;
	width:58%;
	font-size:8px;
	border-radius:150px;
	transition:all 250ms;
	&:hover{
		background-color:#DCDFDC;
	}
`;
 let TipoCuentaDetalle=styled.div`
 	background-color:gray;
 	display:inline;
 	padding:4px;
 	margin-left:10px;
 	border-radius:5px
 `;
	
export default function CardDescription(props){
	let	[mouse,setMouse]=useState("out");
	let { reventa } = props;
	let pais =useSelector(state=>state.pais.pais);
	let shoppingCart = useSelector(state=>state.shoppingCart.reventas);
	let dispatch=useDispatch();

	
	const addCart=(e)=>{
		e.stopPropagation();
		if(!shoppingCart.some(ele=>ele.id===reventa.id)){
			dispatch(modifcarShoppingCart([...shoppingCart,reventa]))
		}
		
		
	}

	return(
		<Container onMouseEnter={()=>{setMouse("in")}} onMouseOut={()=>{setMouse("out")}} onMouseOver={()=>{setMouse("in")}}>
			
		 	<ContainerCard >
		 		<Card consola={reventa.consola} poster={reventa.Cuenta_Juego.Juego.poster} />
		 		{mouse==="in"?
		 		<AddCart title="add to cart" onClick={addCart}>
		 			Agregar al carro <AddShoppingCartIcon style={{ fontSize: 18}}/>
		 		</AddCart>:null}
		 	</ContainerCard>
		 	<Descripcion>
		 		<Nombre>{reventa.Cuenta_Juego.Juego.nombre.toUpperCase()}</Nombre>
		 		
				<TipoCuenta>
					<label>tipo de cuenta :</label> 
					<TipoCuentaDetalle>{reventa.tipo_cuenta}</TipoCuentaDetalle>
				</TipoCuenta>
				<Usuario><label>by :</label> {reventa.User.usuario}</Usuario>
				<Precio><b>{ pais.modenaIcono+" "+ reventa[`precio_${pais.nombre.toLowerCase()}`]}</b> {pais.ISO}</Precio>						 	
		 	</Descripcion>

		</Container>
		)
} 